// extracted by mini-css-extract-plugin
export var animationContainer = "_f0-0";
export var asteriskIcon = "_f0-8";
export var conversationLeftSection = "_f0-4";
export var conversationListItem = "_f0-3";
export var conversationMiddleSection = "_f0-5";
export var conversationRightSection = "_f0-6";
export var detailsContent = "_f0-1";
export var listContainer = "_f0-7";
export var modalContent = "_f0-2";